// extracted by mini-css-extract-plugin
module.exports = {"colMin":"styles_colMin__S-brl","colCheckbox":"styles_colCheckbox__26d5q"};